import axios from 'axios'
import config from '@/config/Config'
export default class BaseApi {
    constructor () {
        this.axiosInstance = axios.create({
            baseURL: config.API
        })
    }
}
